import React from 'react';
import T from 'prop-types';
import { ButtonRow, Button, HorizontalRule } from '@piggybank/core';
import { Form } from '@piggybank/form';
import { Translation } from 'srcAlias/client/locale';
import { EQUITY_INVESTMENT_ACCOUNT } from 'srcAlias/client/enums/productDescriptionCode';
import { OtherEquityMarketCountries } from './OtherEquityMarketCountries';
import AcceptPageRedirectionNonEquitiesProduct from './AcceptPageRedirectionNonEquitiesProduct';
import { callTrackEventAnalyticsFunction } from 'srcAlias/client/global/customHooks/useTrackEventAnalytics';
import { redirectionToCKA } from 'srcAlias/client/utils/redirectionToCKA';
import { isMobileJourney } from 'srcAlias/client/utils/urlParameters';

const AcceptPageButtonSection = ({
  pageName,
  productType,
  productID,
  queryParams,
  initialValuesForm,
}) => {
  const continueButtonClick = (values, event, page, params) => {
    if (values.marketsAcceptPageCheckbox.HK === true) {
      callTrackEventAnalyticsFunction(
        'onChange',
        'otherMarketsHKAcceptPageCheckboxClick',
        values
      );
    }
    if (values.marketsAcceptPageCheckbox.US === true) {
      callTrackEventAnalyticsFunction(
        'onChange',
        'otherMarketsUSAcceptPageCheckboxClick',
        values
      );
    }

    callTrackEventAnalyticsFunction(
      'onClick',
      'continueButtonClickFromAcceptPage',
      values
    );

    redirectionToCKA(values, event, page, params);
  };

  const mobileJourney = isMobileJourney(queryParams);

  return productType === EQUITY_INVESTMENT_ACCOUNT ? (
    <div>
      <Form initialValues={initialValuesForm}>
        {({ values }) => (
          <>
            <div className="otherEquityMarkets">
              <OtherEquityMarketCountries />
            </div>
            <HorizontalRule />
            {!(
              mobileJourney &&
              !values.marketsAcceptPageCheckbox.HK &&
              !values.marketsAcceptPageCheckbox.US
            ) && (
              <ButtonRow>
                <Button
                  onClick={(event) =>
                    continueButtonClick(values, event, pageName, queryParams)
                  }
                >
                  <Translation path={'startInvestingEquityButton'} />
                </Button>
              </ButtonRow>
            )}
          </>
        )}
      </Form>
    </div>
  ) : (
    <AcceptPageRedirectionNonEquitiesProduct
      pageName={pageName}
      queryParams={queryParams}
      productType={productType}
      productID={productID}
    />
  );
};

AcceptPageButtonSection.propTypes = {
  pageName: T.string,
  queryParams: T.object,
  productType: T.string,
  productID: T.string,
  initialValuesForm: T.object,
};

export default AcceptPageButtonSection;
